/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Debris Index Per Spacecraft component for the Impact Evaluation Dashboard 
Author: Deimos Space UK

Version: 1.0
*/

import React, { useState, useEffect } from "react";
import { CardBody, Row, Button, Alert, Col } from "reactstrap";
import Chart from "react-apexcharts";
import { ESA_COLORS } from "../../../../core/models/colors";
import { useParams } from "react-router-dom";
import { getPetition } from "../../../../api/api";
import Spinner from 'react-bootstrap/Spinner';
import { saveFile, rawDataIntoExcel } from "../../../../api/excel-api";

export default function DebrisIndexPerSpacecraft() {

  const { id } = useParams();
  const [barData, setBarData] = useState();
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [exporting, setExporting] = useState(false)
 

  const setDataKyes = (data) => {
  setLabels(data)
  }


  useEffect(() => {
    setLoading(true)
    getPetition(`/api/debris_index/share_of_debris_index_per_spacecraft_for_mission?mission_id=${id}`)
      .then((data) => {
        setSpaceCraft(data)
        setLoading(false)
      })
      .catch((error) => {
        setError(true)
        setLoading(false)
      })
  }, [id]);



  const fetchDataToExcel = () => {
    getPetition(`/api/debris_index/share_of_debris_index_per_spacecraft_for_mission?mission_id=${id}`)
      .then((data) => {
        if (data && data.spacecraft_debris_indices) {
          let excelRows = data.spacecraft_debris_indices.map((item) => {
            return {
              "Spacecraft": item.spacecraft_id,
              "Share of debris index": item.share_of_debris_index_per_spacecraft
            }
          })
          const excelData = rawDataIntoExcel(excelRows, "Debris Index Per Spacecraft")
          saveFile(excelData, 'Debris Index Per Spacecraft')
          setExporting(false)
        }
      })
      .catch((error) => {
        setExporting(false)
      })
  }

  const setSpaceCraft = (spacecraft) => {
    const data = {}
    const dataLabels = []
    if (spacecraft && spacecraft.spacecraft_debris_indices) {
      spacecraft.spacecraft_debris_indices.forEach((element, index) => {
        const key = 'Spacecraft ' + element.spacecraft_id
        data[key] = element.total_index
        dataLabels.push('Plane ' + (index +1))
      });
    }
    setDataKyes(dataLabels)
    getCircularData(data)
  }

  const getCircularData = (data) => {
   
    const circularData = [];
    for (const key in data) {
      circularData.push(data[key])
    }
    setBarData(circularData)

  }

  const apexDonutOpts = {
    chart: {
      height: 240,
      type: "pie",
    },
    labels: labels,
    colors: ESA_COLORS,
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      verticalAlign: "middle",
      floating: false,
      fontSize: "14px",
      offsetX: 0,
      offsetY: 10,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val.toExponential(3);
        },

      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 240,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  };


  return (
    <div className="widget-flat " style={{
      background: 'white',
      boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.06)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}>
      <CardBody>
        <Row style={{ display: 'flex', alignItems: 'center' }}>
          <h6 style={{ color: '#003247' }} className="header-title float-left col " >SHARE OF DEBRIS INDEX PER SPACECRAFT</h6>

          {!error &&
            <>
              <Col>
                
                <Button disabled={exporting} onClick={() => fetchDataToExcel()} style={{ background: '#003247' }} className="float-right"><i className="uil  uil-down-arrow "></i></Button>

              </Col>
            </>
          }
        </Row>
        {
          error ? (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '20px', height: 'auto' }}>
              <Alert color="warning">
                <h4 className="alert-heading">No data available</h4>
                <p>
                  There is no data available for this mission.
                </p>
              </Alert>
            </div>
          )
            : (
              loading ?
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                  <Spinner animation="border" />
                </div>
                :
                <Chart
                  options={apexDonutOpts}
                  series={barData}
                  type="donut"
                  height={390}
                  className="apex-charts"
                />
            )
        }


      </CardBody>
    </div>
  );
}
